import { useEvidencePermission } from '@utils/permission-hook';
import React from 'react';
import { Evidence } from '@eas/common-web';
import { useAuthoredEvidence } from '@components/evidence/authored-evidence';
import { Document } from '@models';
import { EvidenceApiUrl, ExportTag, Permission } from '@enums';
import { useColumns } from './document-columns';
import { Fields } from './document-fields';
import { useValidationSchema } from './document-schema';

export function Documents() {
  const columns = useColumns();
  const validationSchema = useValidationSchema();
  const permissions = useEvidencePermission([Permission.BO_DOCUMENT_MANAGE]);

  const evidence = useAuthoredEvidence<Document>({
    version: 2,
    identifier: 'DOCUMENT',
    apiProps: {
      url: EvidenceApiUrl.DOCUMENT,
    },
    tableProps: {
      columns,
      tableName: 'Dokumenty',
      showBulkActionButton: false,
      reportTag: ExportTag.DOCUMENT,
    },
    detailProps: {
      toolbarProps: {
        title: 'Dokument',
        showBtn: permissions,
      },
      FieldsComponent: Fields,
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
